module.exports = __webpack_public_path__ + "static/media/roll_call_banner_SIDE.252e90ed.png";